import { CONSTANTS } from '../utils';

/*
 * @params endpoint - url with special flag starting with ':replace'
 * f.e. `${baseUrl}/:replaceWithUserId/read-only-users`
 *
 * @params data - data for the flag to be replaced with
 *
 * */
export function getEndpointWithData(endpoint: string) {
	return (data: string) => getEndpoint(endpoint).replace(/:replace\w+/, data);
}

export function getEndpointWithId(endpoint: string) {
	return (id: string) => endpoint.replace(/:replace\w+/, id);
}

/*
 * @params endpoint - url with special flag starting with ':replaceParam{Number}'
 * f.e. `${baseUrl}/:replaceParam0/read-only-users/:replaceParam1`
 *
 * @params data - data for the flag to be replaced with
 *
 * */
export function getEndpointWithParams(endpoint: string) {
	return (...args: string[]) => {
		return endpoint.replace(/:replaceParam(\d+)/g, (match, number) => {
			return typeof args[number] !== undefined ? args[number] : match;
		});
	};
}

export function getEndpoint(endpoint: string) {
	return `${CONSTANTS.baseApiPath}${endpoint}`;
}

export function getAdminEndpoint(endpoint: string) {
	return `${getEndpoint(CONSTANTS.moduleAdminPath)}${endpoint}`;
}
